/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1098
 */

"use strict"

var /* [auto-meaningful-name] */require_959_$$_1785_959$charAt = require(/* 959 */"../1785/959").charAt
module.exports = function (e, t, n) {
  return t + (n ? require_959_$$_1785_959$charAt(e, t).length : 1)
}
